import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledCustomUploadList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
`;

export const StyledCustomDocument = styled.div`
  .custom-document-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border: 1px solid ${(props) => props.theme.colorBorder};
    border-radius: 8px;
    background: ${(props) => props.theme.white};
    transition: all 0.3s ease;

    &:hover {
      border-color: ${(props) => props.theme.colorPrimary};
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .file-info {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
      min-width: 0;

      .anticon {
        font-size: 20px;
        color: ${(props) => props.theme.colorPrimary};
        flex-shrink: 0;
      }

      .file-details {
        display: flex;
        flex-direction: column;
        gap: 4px;
        flex: 1;
        min-width: 0;

        .file-name {
          color: ${(props) => props.theme.colorText};
          overflow: hidden;
          margin: 0;
        }

        .file-size {
          color: ${(props) => props.theme.grey};
          font-size: 12px;
        }

        .file-meta {
          display: flex;
          gap: 25px;
          margin-top: 4px;

          .file-detail {
            font-size: 14px;
            color: ${(props) => props.theme.dimmedTextColor};
            display: flex;
            gap: 4px;
          }
        }
      }
    }

    .file-actions {
      display: flex;
      gap: 8px;
      flex-shrink: 0;

      .ant-btn {
        height: 28px;
        padding: 4px 8px;
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.colorBorder};
        background: ${(props) => props.theme.white};
        color: ${(props) => props.theme.grey};
        transition: all 0.3s ease;

        &:hover {
          border-color: ${(props) => props.theme.colorPrimary};
          color: ${(props) => props.theme.colorPrimary};
        }

        &.ant-btn-icon-only {
          width: 28px;
          padding: 0;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .custom-document-item {
      .file-info {
        .file-details {
          gap: 18px;

          .file-meta {
            flex-direction: column;
            gap: 4px;
          }
        }
      }
    }
  }
`;
